<script setup lang="ts">
import { useCases } from '../../../content'
</script>

<template>
  <section id="use-cases">
    <div class="container">
      <div
        v-for="(useCase, index) in useCases"
        :key="useCase.eyebrow"
        :class="['use-case', { 'use-case--reverse': index % 2 === 1 }]"
      >
        <div class="use-case__image animate animate--fade-right">
          <img :src="useCase.image" :alt="useCase.imageAlt">
        </div>

        <div class="use-case__content">
          <span class="use-case__eyebrow animate animate--fade-up">{{ useCase.eyebrow }}</span>
          <h2 class="use-case__title animate animate--fade-up animate--delay-1">{{ useCase.headline }}</h2>
          <p class="use-case__description animate animate--fade-up animate--delay-2">{{ useCase.description }}</p>
          <a
            :href="useCase.cta.href"
            class="btn btn--primary animate animate--fade-up animate--delay-3"
          >
            {{ useCase.cta.label }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
